import styled from 'styled-components'
import { ITextAreaContainer } from './types'

export const Container = styled.div<ITextAreaContainer>`
    width: ${props => props.width || 100}%;

    @media (max-width: 768px) {
        width: ${props => props.widthMobile || 100}%;
    }
`
export const TextAreaLabel = styled.label`
    width: 100%;
    color: ${props => props.theme.colors.white};
`

export const TextAreaField = styled.textarea`
    width: 100%;
    height: 150px;
    padding: 10px;
    margin: 7px 0;
    font-size: 16px;
    border-radius: 10px;

    &:disabled {
        color: ${props => props.theme.colors.white};
    }
`